module.exports = __webpack_public_path__ + "static/bead-butt-door-e345ff40f0af3184de75596d186c99c0.png";